import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import Editor from '../../Editor';
import cn from 'classnames';
import { extConfig } from './config';
import viewerStyles from '../../../Viewer/presets/Literature/Literature.scss';
import s from './Literature.scss';
const LiteratureEditor = (props)=>{
    return /*#__PURE__*/ React.createElement(Editor, _object_spread_props(_object_spread({}, props), {
        withinModal: true,
        presetId: "journal",
        className: cn(s['root'], viewerStyles['root']),
        extensionConfig: extConfig
    }));
};
LiteratureEditor.displayName = 'LiteratureEditor';
export default LiteratureEditor;

//# sourceMappingURL=Literature.js.map